import { getAPIURL } from "./utils";
import { withActiveToken } from "../lib/auth";
import { fetchProtected } from "./utils";

export const OnCreateTable = async (
  schema,
  callback,
  activeBusiness,
  onError,
  router,
  headers
) => {
  withActiveToken(
    () => {
      fetchProtected(
        "POST",
        `businesses/${activeBusiness.uuid}/tables/`,
        schema,
        headers
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
};


export const onCreateRow = async (
  tableId,
  callback,
  row,
  activeBusiness,
  onError,
  router
) => {
  withActiveToken(
    () => {
      fetchProtected(
        "POST",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/rows/`,
        row
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      }),
        router
    },
  );
};

export const renderTables = async (callback, activeBusiness, onError, router, peg, row_namespace, table_namespace) => {
  withActiveToken(
    () => {
      let url = `businesses/${activeBusiness.uuid}/tables/?peg=${peg || ""}`;
      if (row_namespace) {
        url += `&&row_namespace=${row_namespace}`;
      }
      if (table_namespace) {
        url += `&&namespace=${table_namespace}`;
      }
      
      fetchProtected(
        "GET",
        url
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
        callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
}


export const renderTable = async (tableId, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "GET",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/`
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
};
export const updateTable = async (tableId, table, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "PATCH",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/`,
        table
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
}
export const deleteTable = async (tableId, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "DELETE",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/`
      ).then((res) => {
        if (res.ok) {
          callback?.();
          return Promise.resolve();
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
}
export const updateRow = async (tableId, rowId, row, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "PATCH",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/rows/${rowId}/`,
        row
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      }),
        router
    },
  )
}
export const deleteRow = async (tableId, rowId, activeBusiness, callback, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "DELETE",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/rows/${rowId}/`
      ).then((res) => {
        if (res.ok) {
          callback?.();
          return Promise.resolve();
        }
        // A rejected delete used to resolve silently: the row vanished from the
        // UI and came back on the next load. Report it so callers can react.
        return res.json()
          .catch(() => ({ detail: `Request failed with status ${res.status}` }))
          .then((json) => {
            onError?.(json);
            return Promise.reject(json);
          });
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
}
export const renderRows = async (tableId, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "GET",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/rows/`
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
};

export const renderRecentTables = async (callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "GET",
        `businesses/${activeBusiness.uuid}/table_view_histories/`
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
};
export const addRecentTables = async (tableId, staffId, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "POST",
        `businesses/${activeBusiness.uuid}/table_view_histories/`,
        { table: tableId, owner: staffId }
      ).then((res) => {
        return Promise.resolve();
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
};
export const updateTableIndividualPermission = async (tableId, staffId, permission, activeBusiness, callback, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "POST",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/individual-permissions/`,
        { staff: staffId, permission: permission }
      ).then((res) => {
        if(res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
};

export const changeTableIndividualPermission = async (tableId, permissionId, permission, activeBusiness, callback, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "PATCH",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/individual-permissions/${permissionId}/`,
        { permission: permission }
      ).then((res) => {
        if(res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
};

export const deleteTableIndividualPermission = async (tableId, permissionId, activeBusiness, callback, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "DELETE",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/individual-permissions/${permissionId}/`
      ).then((res) => {
        if(res.ok) {
          callback?.();
          return Promise.resolve();
        }
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
}

export const renderTableIndividualPermission = async (tableId, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "GET",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/individual-permissions/`
      ).then((res) => {
        if(res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
      }).catch((error) => {
        onError?.(error);
        return Promise.reject(error);
      });
    },
    router
  );
}
export const renderPegs = async (callback, name, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "GET",
        `pegs/?name=${name || ""}`
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      });
    },
    router
  );
};

export const bulkCreateRows = async (tableId, rows, callback, activeBusiness, onError, router) => {
  withActiveToken(
    () => {
      fetchProtected(
        "POST",
        `businesses/${activeBusiness.uuid}/tables/${tableId}/bulk-create/`,
        rows 
      ).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            callback?.(json);
          });
        }
        return res.json().then((json) => {
          onError?.(json);
          return Promise.reject(json);
        });
      }),
        router
    },
  );
}
// TODO: Implement create multiple rows, onCreateRows
